import { css } from '@emotion/css';

export const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
});
